import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

// Components
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Popover from '@material-ui/core/Popover';
import { SketchPicker } from 'react-color';

// Styles
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    label: {
      flex: '0 1 auto',
      width: 360,
      marginRight: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      ...theme.typography.body2,
      fontWeight: theme.typography.fontWeight.bold,
      marginBottom: theme.spacing(1),
    },
    subtitle: {
      ...theme.typography.caption,
    },
    formControl: {
      flex: '0 0 auto',
      minWidth: 'auto',
      marginRight: theme.spacing(3),
    },
    textFieldRoot: {
      borderRadius: 4,
      border: 'solid 1px rgba(155,155,155, 0.5)',
      padding: theme.spacing(0.75, 1.25),
      width: 123,
      position: 'relative',
      fontWeight: '6',
    },
    input: {
      backgroundColor: theme.palette.common.white,
      padding: 0,
      fontSize: 16,
      width: 'calc(100% - 24px)',
    },
    inputAdornment: {
      width: 28,
      height: 30,
    },
    boxHitBox: {
      width: 28,
      height: 28,
      padding: 4,
      position: 'absolute',
      top: 5,
      left: 6,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
    },
    box: {
      borderRadius: 4,
      border: 'solid 1px rgba(155,155,155, 0.5)',
      width: 24,
      height: 24,
      flex: '0 0 auto',
    },
    description: {
      ...theme.typography.caption,
      flex: '1 1 auto',
      marginRight: theme.spacing(2),
    },
  };
};

function ColorRow({ className, classes, title, value, onChange, description }) {
  const [open, setOpen] = useState(false);
  const boxHitBoxRef = useRef(null);

  const handlePickerChange = color => onChange(color.hex);
  const handleTextChange = e => onChange(e.currentTarget.value);
  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.label}>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{description}</div>
      </div>
      <TextField
        placeholder="#HEX000"
        className={classes.formControl}
        onChange={handleTextChange}
        value={value}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: classes.textFieldRoot,
            input: classes.input,
          },
          startAdornment: (
            <InputAdornment
              className={classes.inputAdornment}
              onClick={handleClick}
              position="start"
            >
              <div ref={boxHitBoxRef} className={classes.boxHitBox}>
                <div className={classes.box} style={{ backgroundColor: value }} />
              </div>
            </InputAdornment>
          ),
        }}
      />
      <Popover
        open={open}
        anchorEl={boxHitBoxRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <SketchPicker color={value} onChange={handlePickerChange} disableAlpha />
      </Popover>
    </div>
  );
}

ColorRow.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  description: PropTypes.node.isRequired,
};

export default withStyles(styles)(ColorRow);
